import { UserType } from '../../entities/tenant/user.type';
import { AppSecurityRight } from '../modules/app.security';
import { withDerivedCrmRecordRights } from '../modules/crm.record.rights';
import { CrmSecurityRight } from '../modules/crm.security.module';
import { DashboardSecurityRight } from '../modules/dashboard.security.module';
import { IndividualComplianceSecurityModule } from '../modules/individual.compliance.security.module';
import { SecurityRole, SecurityRoleType } from '../security.role';


export class EmployeeCompliance implements SecurityRole {

    _id = 'ea005bb7-62b3-4d2c-afb5-52eeb461be53';
    system = true;
    hidden = false;
    name = SecurityRoleType.EmployeeCompliance;
    type = UserType.Employee;
    description = 'Can manage individual compliance.';
    rights = withDerivedCrmRecordRights([
        AppSecurityRight.LoginWeb,
        ...new IndividualComplianceSecurityModule().allRights,
        CrmSecurityRight.CanAccess,
        CrmSecurityRight.ManageEmployees,
        CrmSecurityRight.ManageSubcontractors,
        // DashboardSecurityRight.CanViewSystemDashboards,
        DashboardSecurityRight.CanCreateDashboards,
    ]);

}

